import styled from 'styled-components'

export const ManagerSettingsContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex-shrink: 0;
	flex-grow: 1;
	align-items: stretch;
	justify-content: flex-start;
	padding: 16px;
	width: 100%;
	max-width: 768px;
`
